(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pg-eu-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pg-eu-notice')) {
  customElements.define('pg-eu-notice', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const dialog = this.querySelector('dialog');
      const image = this.querySelector('.pg-eu-notice__image');
      const zoom = this.querySelector('[data-eu-zoom]');
      this.closest('.shopify-section').addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-eu-notice-open]');
        if (!trigger || trigger.getAttribute('aria-controls') !== dialog.id) return;
        event.preventDefault();
        this.opener = trigger;
        image.removeAttribute('data-zoomed');
        zoom.setAttribute('aria-pressed', 'false');
        dialog.showModal();
        image.scrollTo(0, 0);
      }, options);
      this.querySelector('[data-eu-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), options);
      zoom.addEventListener('click', () => {
        const enlarged = image.toggleAttribute('data-zoomed');
        zoom.setAttribute('aria-pressed', String(enlarged));
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
